import React, { Component } from 'react';
import Month from 'react-big-calendar/lib/Month';
import moment from 'moment';
import {
  nowDate,
  dateIsPast,
  dateTimeIsPast,
  isWeekend,
  isInRange,
  expandRange,
} from './helpers_common';
import { Pressable, StyleSheet, View } from 'react-native';

const styles = StyleSheet.create({
  calTimeSlot: {
    width: 0,
    height: 0,
    alignSelf: 'center',
    justifySelf: 'center',
  },
});

function customMonthComp(displayTextAsOffRange, displayTextAsInSelectedRange) {
  class CustomMonth extends Month {
    constructor(props) {
      super(props);

      this._existingReaderDateHeading = this.readerDateHeading;
      this.readerDateHeading = this.readerDateHeadingOverride;
    }
    readerDateHeadingOverride = (_ref) => {
      const date = _ref.date;
      const elem = this._existingReaderDateHeading(_ref);

      let className = elem.props.className;
      if (displayTextAsOffRange?.(date)) className += ' rbc-off-range';
      else {
        if (displayTextAsInSelectedRange(date)) {
          className += ' rbc-now';
        }
        const isToday = moment(date).isSame(moment(), 'day');
        if (isToday) className += ' rbc-today-cell';
      }

      return React.cloneElement(elem, { className });
    };
  }
  return CustomMonth;
}

function customEventWrapperComp(dotStyle, onHoverIn, onHoverOut) {
  class EventWrapperView extends Component {
    handleCalContainerLayout = ({ nativeEvent }) => {
      this._layout = {
        ...nativeEvent.layout,
        top: nativeEvent.layout.top + window.scrollY,
      };
    };
    render() {
      return (
        <Pressable
          style={styles.calTimeSlot}
          onHoverIn={({ nativeEvent }) => {
            const startDate = new Date(this.props.event.startDate);
            onHoverIn?.({
              startDate,
              viewLayout: this._layout,
              mousePos: { x: nativeEvent.x, y: nativeEvent.y },
            });
          }}
          onHoverOut={({ nativeEvent }) => {
            onHoverOut?.();
          }}
          onLayout={this.handleCalContainerLayout}
        >
          <View style={dotStyle} />
        </Pressable>
      );
    }
  }
  return EventWrapperView;
}

class TouchCellWrapper extends Component {
  render() {
    const { children, value, onSelectSlot, calCellBGClassForDate } = this.props;
    const child = React.Children.only(children);
    let className = child.props.className + (calCellBGClassForDate?.(value) || '');
    return React.cloneElement(child, {
      onTouchStart: (e) => {
        if (e.nativeEvent.changedTouches.length) {
          this._touchTrackerX = e.nativeEvent.changedTouches[0].clientX || 0;
          this._touchTrackerY = e.nativeEvent.changedTouches[0].clientY || 0;
        }
      },
      onTouchEnd: (e) => {
        let clientX = 0;
        let clientY = 0;
        if (e.nativeEvent.changedTouches.length) {
          clientX = e.nativeEvent.changedTouches[0].clientX || 0;
          clientY = e.nativeEvent.changedTouches[0].clientY || 0;
        }
        const diffX = Math.abs(this._touchTrackerX - clientX);
        const diffY = Math.abs(this._touchTrackerY - clientY);

        if (diffX < 20 && diffY < 20) {
          onSelectSlot({ action: 'click', slots: [value], start: value });
        }
      },
      className,
    });
  }
}

module.exports = {
  nowDate,
  dateIsPast,
  dateTimeIsPast,
  isWeekend,
  isInRange,
  expandRange,
  customMonthComp,
  customEventWrapperComp,
  TouchCellWrapper,
};
